module.exports = "//public.getcloudapp.com/packs/media/images/icons-invite-default-3ef60326ebd732a0a317c0e73b558240.svg";